// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__39Fh4","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1aUza"};